import React from 'react';
import { fetcher } from '../lib/fetch';
import useSWR from 'swr';
import { parseRangeMode } from '../lib/rangeMode';

const configUrl = '/api/v1/config';

export function useIsWaterTracking() {
  const { data } = useSWR(configUrl, fetcher, { refreshInterval: 5000, dedupingInterval: 100 });
  if (!data) return false;
  try {
    const mode = parseRangeMode(data.range_mode);
    return mode.trackingMode() === "Water tracking";
  } catch {
    return false;
  }
}

function ShowTrackingMode() {
    const { data, error } = useSWR(configUrl, fetcher, { refreshInterval: 5000, dedupingInterval: 100 });
    if (error) {
        console.warn("Unable to fetch config")
        return null
    }
    if (!data) {
        return null
    }
    try {
        const mode = parseRangeMode(data.range_mode);
        return (<span>{mode.trackingMode()}</span>);
    } catch (e) {
        console.warn("Unable to parse range mode", e);
        return (<span>Unknown mode</span>);
    }
}

export { ShowTrackingMode };
